import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopictwo/GLB_Cubeta.glb";
import { GUI } from "dat.gui";

export class TrayProduct extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Cubeta = gltf.scene.getObjectByName("Cubeta", true);
		});
	}

	helperObjectGeneral() {
		const gui = new GUI();
		const folferMostrador = gui.addFolder("tray");
		const limit = 20;
		folferMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(this, "visible").name("Visible");
	}

	helpersChild() {
		this.helperMethod("Cubeta", this.Cubeta);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 20;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");

		folferMostrador
			.addColor({ color: object.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				object.material.color.set(value);
			});

		folferMostrador
			.add(object.material, "emissiveIntensity", 0, 5)
			.name("Intensidad de Emisión")
			.onChange(function (intensity) {
				object.material.emissiveIntensity = intensity;
			});

		const emissiveControl = folferMostrador.addColor({ emissive: object.material.emissive.getHex() }, "emissive").name("Color de Emisión");
		emissiveControl.onChange(function (color) {
			object.material.emissive.set(color);
		});
	}

	renderAnimations() { }
}
